import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import Header from "components/common/Header/Header";
import SelectOption from "components/common/Select/Select";
import SideBarNew from "components/common/SideBar/SideBarNew";
import {
  REPORTING_BREADCRUMB,
  REPORTING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import { LoginContext } from "helpers/LoginContext";
import React, { useContext, useEffect, useState } from "react";


import PaginationComponent from "components/common/Pagination/index";
import {

  emptyPaginationObj,
  REPORTING_LIMIT,
  SORT_TYPE,
  TIME_FORMAT_OPTIONS,
} from "Constants/constant";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import TableHeader from "components/common/Table/TableHeader";
import { apiPostRequest } from "helpers/Requests";
import { URL_REPORTING_TIMESHEET_REPORTS } from "store/services/URL";
import moment from "moment";
import _ from "lodash";
import { toast } from "react-toastify";
import { addMonths, exportTOExcel} from "Utils/utils";
import useReportExport from "../useReportExport";
import {
  ReportFilterActions,
  ReportFilterField,
  ReportFilterGrid,
  ReportFiltersShell,
  ReportPageContent,
  ReportTableSection,
} from "../reportFilterUi";
import { withReportSortOnUrl } from "../reportExportUtils";

import { Timesheet_Status } from "store/constants";
import TimesheetSubTable from "./TimesheetReportsSubTable";
import useCareLabels from "hooks/useCareLabels";

const TimesheetReports = ({
  getTeamManagmentListCall,
  teamManagementList,
  getParticipantList,
  spParticipants,
}) => {
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const { participantLabel } = useCareLabels();
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [isDisableSearch, setIsDisableSearch] = useState(false);

  useEffect(() => {
    const filters = {
      page: 1,
      per_page: 500,
      search: null,
    };
    getParticipantList({ filters, bodyFilter: null });
    getTeamManagmentListCall({ filters, bodyFilter: null });
  }, []);

  const [workerList, setWorkerList] = useState([]);
  const [participantList, setParticipant] = useState([]);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [search, setSearch] = useState(null);
  const [reportList, setReports] = useState(null);
  const [loader, setLoader] = useState(false);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [page, setPage] = useState(1);
  const [sortDescending, setSortDescending] = useState(
    paginationObj.sort_order === SORT_TYPE.DESC ? true : false
  );
  const [sortBy, setSortBy] = useState(paginationObj.sort_field);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [status, setStatus] = useState(null);
  const [timeFormat, setTimeFormat] = useState({
    label: "24 Hour",
    value: "24_hour",
  });

  useEffect(() => {
    const updateLists = async () => {
      const workers =
        teamManagementList?.employees?.data?.map((item) => ({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.id,
        })) || [];

      const sortedWorkers = workers.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      const participants =
        spParticipants?.participant?.data?.map((item) => ({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.id,
        })) || [];

      const sortedParticipants = participants.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      setParticipant([{ label: "All", value: "all" }, ...sortedParticipants]);
      setWorkerList([{ label: "All", value: "all" }, ...sortedWorkers]);
    };

    updateLists();
  }, [teamManagementList, spParticipants]);

  const [isInitialRender, setIsInitialRender] = useState(true);
  const { runExport, QueuedModal, getExportSortFilters } = useReportExport(
    "timesheet_report",
    "Timesheet Report",
    { sortBy, sortDescending }
  );

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      return;
    }

    fetchListReports();
  }, [page]);

  useEffect(() => {
    if (search === null) return;
    const timeOutId = setTimeout(() => fetchListReports(), 600);
    return () => clearTimeout(timeOutId);
  }, [search]);

  const fetchListReports = async (
    isClearAll = false,
    report = null,
    filters = null
  ) => {
    if (!fromDate && !toDate) {
      toast("Select create date range to get data");
      return;
    }

    let url = `${URL_REPORTING_TIMESHEET_REPORTS}?per_page=25&page=${page}`;
    url = withReportSortOnUrl(url, filters || {}, sortBy, sortDescending);
    const payload = {
      search: search ? search : "",
      format: timeFormat?.value || "24_hour",
      participant: isClearAll
        ? "all"
        : selectedParticipant
        ? selectedParticipant?.value
        : "all",
      worker: isClearAll
        ? "all"
        : selectedWorker
        ? selectedWorker?.value
        : "all",
      status: isClearAll ? "all" : status ? status?.value : "all",

      timesheet_date_range: isClearAll
        ? "all"
        : toDate && fromDate
        ? [fromDate, toDate]
        : "all",
    };
    if (report) {
      await runExport({
        format: report,
        payload,
        syncUrl: url,
        filters: filters || {},
        totalRows: paginationObj?.total,
        fallbackTotal: reportList?.timesheets?.total,
        setLoader,
        onSyncExcel: (downloadUrl) => window.open(downloadUrl, "_blank"),
        onSyncPdf: (downloadUrl) => window.open(downloadUrl, "_blank"),
      });
      return;
    }

    setLoader(true);
    await apiPostRequest(url, payload)
      .then((res) => {
        if (res.status === 200) {
          setLoader(false);
          setReports(res?.data?.data);
          setPaginationObj((prev) => ({
            ...prev,
            total: res?.data?.data?.timesheets?.total,
            totalPages: Math.ceil(
              res?.data?.data?.timesheets?.total /
                res?.data?.data?.timesheets?.per_page
            ),
          }));
        }
      })
      .catch((error) => {
        toast.error(`${error}`);
        console.log({ error });
        setLoader(false);
      });
  };
  const handleFileDownLoad = (e) => {
    fetchListReports(false, e, getExportSortFilters());
  };

  const handleSearch = () => fetchListReports(false);

  const handleClearFilters = () => {
    setSelectedWorker(null);
    setSelectedFromDate(null);
    setSearch(null);
    setReports([]);
    setFromDate(null);
    setToDate(null);
    setSelectedParticipant(null);
    setStatus(null);
  };

  const exportTOExcelFile = (reportData) => {
    const transformedData =
      reportData &&
      reportData?.timesheets?.length > 0 &&
      reportData?.timesheets?.map((item) => {
        const workersString =
          item.participants && item?.participants?.length > 0
            ? item.participants
                .map((el) => `${el.first_name} ${el.last_name}`)
                .join(", ")
            : "";

        const shiftNotes =
          item?.shift_notes?.length > 0
            ? item?.shift_notes
                ?.filter((el) => el?.notes)
                .map(
                  (singleShiftNote) =>
                    `Shift Notes for (${
                      singleShiftNote?.participant?.first_name
                    } ${
                      singleShiftNote?.participant?.last_name
                    }): \n${singleShiftNote.notes.replace(/\n/g, " ")}\n\n`
                )
                .join("")
            : "N/A";

        return {
          Participants: workersString || "N/A",
          Worker:
            `${item?.employee_profile?.first_name} ${item?.employee_profile?.last_name}` ||
            "N/A",

          TimeSheetDate: item?.time_sheet_date
            ? moment(item?.time_sheet_date).format("DD/MM/YYYY")
            : "N/A",
          StartTime: item?.start_time ? item?.start_time : "N/A",
          EndTime: item?.end_time ? item?.end_time : "N/A",
          TimesheetLength: item?.timesheet_length || 0,
          Incident: item?.incident || "N/A",
          Status: item?.status || "N/A",
          KMs: item?.km || 0,
          Comment: item?.comment || "N/A",

          Shift_Notes: shiftNotes || "N/A",
          Service_Category: item?.service_type?.name || "N/A",
          NDIS_Item_Name: item?.ndis_item?.support_item_name || "N/A",
          NDIS_Item_Number: item?.ndis_item?.support_item_number || "N/A",
          Starting_Coordinates: `${item?.shift?.start_lat || "N/A"} , ${
            item?.shift?.start_lng || "N/A"
          } `,
          Ending_Coordinates: `${item?.shift?.end_lat || "N/A"} , ${
            item?.shift?.end_lng || "N/A"
          }`,
          Shift_Accociated_Cost: item?.comment ? `$${item?.comment}` : "N/A",
        };
      });
    if (
      !transformedData ||
      transformedData === undefined ||
      transformedData?.length === 0
    ) {
      toast("No data found!");
      return;
    }

    exportTOExcel(transformedData);
  };

  const handleFetch = (obj) => {
    fetchListReports(false, null, { ...obj });
  };

  const flipSort = (by) => {
    setSortBy(by);
    setSortDescending(!sortDescending);
    handleFetch({
      sort_field: by,
      sort_order: !sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };

  return (
    <div className='min-h-full'>
      <SideBarNew />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col `}
      >
        <main className='flex-1 bg-gray-50 min-h-screen'>
          <Header
            title='Timesheet Reports'
            breadcrumb={
              <Breadcrumb
                pages={REPORTING_BREADCRUMB(
                  REPORTING_BREADCRUMB_PAGES.TIMESHEET_REPORTS
                )}
              />
            }
          />
          <ReportPageContent>
            <ReportFiltersShell>
              <ReportFilterGrid columns={4}>
                <ReportFilterField label={participantLabel}>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='pt_id'
                    isSearch={true}
                    data={participantList || []}
                    selectedOption={selectedParticipant}
                    handleChange={(e) => setSelectedParticipant(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Worker'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='worker_id'
                    isSearch={true}
                    data={workerList || []}
                    selectedOption={selectedWorker}
                    handleChange={(e) => setSelectedWorker(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Date Range of Timesheet (Max 3 Months)' required>
                  <DateRangePickerNew
                    handleCancel={() => {
                      setFromDate(null);
                      setToDate(null);
                      setReports([]);
                    }}
                    handleChange={(obj) => {
                      if (obj && obj.fromDate && obj.toDate) {
                        obj.fromDate && setFromDate(obj.fromDate);
                        obj.toDate && setToDate(obj.toDate);
                      }
                    }}
                    setSelectedFromDate={setSelectedFromDate}
                    fromDate={fromDate}
                    toDate={toDate}
                    maxDate={addMonths(selectedFromDate, 3)}
                    setIsDisableSearch={setIsDisableSearch}
                  />
                </ReportFilterField>
                <ReportFilterField label='Status'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='worker_id'
                    isSearch={true}
                    data={Timesheet_Status || []}
                    selectedOption={status}
                    handleChange={(e) => setStatus(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Time Format'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='time_format'
                    data={TIME_FORMAT_OPTIONS || []}
                    selectedOption={timeFormat}
                    handleChange={(e) => setTimeFormat(e)}
                  />
                </ReportFilterField>
              </ReportFilterGrid>
              <ReportFilterActions
                onSearch={handleSearch}
                onClear={handleClearFilters}
                onExport={handleFileDownLoad}
                isLoading={loader}
                isSearchDisabled={isDisableSearch}
                isUserGracePeriodOver={isUserGracePeriodOver}
              />
            </ReportFiltersShell>
            <ReportTableSection>
                  <table className='border min-w-full divide-y divide-gray-300'>
                    <thead
                      // style={{ top: "130px" }}
                      className='bg-gray-50 sticky z-[5]'
                    >
                      <tr>
                        <TableHeader isSort={false} label={""} cssClass='bg-blue-50 pl-4' />
                        <TableHeader isSort={false} label={participantLabel} cssClass='bg-blue-50 pl-4' />

                        <TableHeader isSort={false} label={"Worker"} cssClass='bg-blue-50 px-0' />

                        <TableHeader
                          sortName='time_sheet_date'
                          flipSort={flipSort}
                          sortBy={sortBy}
                          sortDescending={sortDescending}
                          label={"Timesheet Date"}
                          cssClass='bg-blue-50 px-0'
                        />

                        <TableHeader
                          sortName='worker_start_time'
                          flipSort={flipSort}
                          sortBy={sortBy}
                          sortDescending={sortDescending}
                          label={"Worker Start Time"}
                          cssClass='bg-blue-50 px-0'
                        />

                        <TableHeader
                          sortName='worker_end_time'
                          flipSort={flipSort}
                          sortBy={sortBy}
                          sortDescending={sortDescending}
                          label={"Worker End Time"}
                          cssClass='bg-blue-50 px-0'
                        />

                        <TableHeader
                          sortName='timesheet_length'
                          flipSort={flipSort}
                          sortBy={sortBy}
                          sortDescending={sortDescending}
                          label={"Total Time"}
                          cssClass='bg-blue-50 px-0'
                        />

                        <TableHeader isSort={false} label={"Status"} cssClass='bg-blue-50 px-0' />
                        <TableHeader isSort={false} label={"Shift Notes"} cssClass='bg-blue-50 px-0' />

                        <TableHeader isSort={false} label={"Incidents"} cssClass='bg-blue-50 px-0' />

                        <TableHeader
                          sortName='km'
                          flipSort={flipSort}
                          sortBy={sortBy}
                          sortDescending={sortDescending}
                          label={"KMs"}
                          cssClass='bg-blue-50 px-0'
                        />

                        <TableHeader
                          isSort={false}
                          label={"Shift Associated Cost $"}
                          cssClass='bg-blue-50 px-0'
                        />
                      </tr>
                    </thead>
                    <tbody className='divide-y divide-gray-200 bg-white overflow-y-auto'>
                      {loader ? (
                        <tr className='bg-white'>
                          <td
                            colSpan={14}
                            className='py-6 text-center bg-white'
                          >
                            <div
                              className={`flex flex-col w-full min-h-screen  items-center justify-start`}
                            >
                              <CircularLoader
                                classes='flex justify-center items-center'
                                classloader='loader-l'
                              />
                            </div>
                          </td>
                        </tr>
                      ) : reportList !== null &&
                        reportList?.timesheets?.data?.length > 0 ? (
                        reportList?.timesheets?.data?.map(
                          (timesheet, index) => (
                            <TimesheetSubTable item={timesheet} key={index} />
                          )
                        )
                      ) : (
                        <tr>
                          <td
                            colSpan={14}
                            className='py-6 text-center text-red-600'
                          >
                            No data found. Please adjust your filters to get
                            relevant results
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
            </ReportTableSection>

              {reportList && reportList?.timesheets?.data?.length > 0 && (
                <div className='mt-3'>
                  <PaginationComponent
                    page={paginationObj?.page || 1}
                    activeListLength={reportList?.timesheets?.data || []}
                    limit={REPORTING_LIMIT}
                    totalList={paginationObj?.total}
                    handlePagination={(e) => {
                      setPage(e);
                      const obj = paginationObj;
                      obj.page = e;
                      setPaginationObj({ ...obj });
                    }}
                    totalPages={paginationObj?.totalPages}
                  />
                </div>
              )}
          </ReportPageContent>
        </main>
      </div>
      <QueuedModal />
    </div>
  );
};

export default TimesheetReports;
